<template>
  <el-date-picker align="center" :size="size" :type="type" :format="format" v-model="currentValue" :placeholder="placeholder" @change="onValueChange" />
</template>

<script>
export default {
  name: "MsgDatePicker",
  props: {
    size: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      default: undefined,
    },
    format: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    value: {
      type: [Date, String],
      default: undefined,
    },
  },
  data() {
    return {
      currentValue: null,
    };
  },
  created() {
    this.currentValue = this.value;
  },
  methods: {
    onValueChange() {
      this.$emit("change", this.currentValue);
    }
  },
  watch: {
    value(newValue) {
      this.currentValue = this.value;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/customComponents/MsgDatePicker.vue